module.exports = __webpack_public_path__ + "img/htcm_06.08d20196.jpg";